export default __webpack_public_path__ + "static/media/NP.d6563164.svg";